import { Reducer, Action } from 'redux';
import { call, select, all, delay, put, takeEvery, fork } from 'redux-saga/effects';
import { actionCreators as layoutActionCreators } from 'src/reducers/Layout';
import { selectors as authSelectors } from 'src/reducers/Auth';
import Api from '../api';
import Tag from 'src/models/Tag';
import { IRootState } from '.';
import PagedResultSet from 'src/models/common/PagedResultSet';

export interface ITagState {
    tags: Array<Tag>;
}

const initialState: ITagState = {
    tags: undefined,
};

export enum actionTypes {
    GET_PROJECT_TAGS = '[tags] GET_PROJECT_TAGS',
    GET_PROJECT_TAGS_SUCCESS = '[tags] GET_PROJECT_TAGS_SUCCESS',
}

export const actionCreators = {
    getProjectTags: (clientNumber: number, projectNumber: number) => {
        return { type: actionTypes.GET_PROJECT_TAGS, payload: { clientNumber, projectNumber } };
    },
    getProjectTagsSuccess: (tags: PagedResultSet<Tag>) => {
        return { type: actionTypes.GET_PROJECT_TAGS_SUCCESS, payload: tags.items };
    },
};

const reducer: Reducer<ITagState> = (state: ITagState = initialState, action: Action): ITagState => {
    switch (action.type) {
        case actionTypes.GET_PROJECT_TAGS_SUCCESS: {
            const payload = (action as { type: string; payload: Array<Tag> }).payload;
            return {
                ...state,
                tags: payload,
            };
        }
        default:
            return state;
    }
};

export default reducer;

const tagSelector = (state: IRootState): Array<Tag> => state.tags.tags;

export const selectors = {
    tags: tagSelector,
};

const sagas = {
    getProjectTags: function* (action: { type: string; payload: { clientNumber: number; projectNumber: number } }): unknown {
        yield call(layoutActionCreators.waitIniitalLoadState);
        const jwt = yield select(authSelectors.jwt);

        const [result] = yield all([call(Api.Tags.get, action.payload.clientNumber, action.payload.projectNumber, jwt), delay(200)]);
        yield put(actionCreators.getProjectTagsSuccess(result));
    },
};

const watches = {
    getProjectTags: function* () {
        yield takeEvery(actionTypes.GET_PROJECT_TAGS, sagas.getProjectTags);
    },
};
export function* saga() {
    yield fork(watches.getProjectTags);
}



// WEBPACK FOOTER //
// ./src/reducers/Tag.ts